<template>
  <button class="queue-button" :type="type" @click="$emit('click', $event)">
    <slot>{{ label }}</slot>
  </button>
</template>

<script>
export default {
  name: 'QueueButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.queue-button {
  width: 280px;
  box-sizing: border-box;
  padding: 16px 14px;
  border: 2px solid #3b82f6;
  border-radius: 12px;
  background: #fff;
  color: #3b82f6;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}

.queue-button:hover {
  background: #3b82f6;
  color: #fff;
}

.queue-button:focus {
  border-color: #2563eb;
}
</style>
